// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PZoomOutOutlinedSvg from "@fishx/icons-svg/es/asn/PZoomOutOutlined";
import FishxIcon from '../components/FishxIcon';

var PZoomOutOutlined = function PZoomOutOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PZoomOutOutlinedSvg
  }));
};

PZoomOutOutlined.displayName = 'PZoomOutOutlined';
export default React.forwardRef(PZoomOutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PZoomOutOutlined.js
// module id = 3748
// module chunks = 0